import React, { useState } from "react";
import { ValidationResult } from "sprint-common-web";

import { UpdateFileRecordAudioTechnicalRequest } from "../../../../../../../../common/api/master-api/file-records/update/technical/audio/UpdateFileRecordAudioTechnicalRequest";
import { useFileRecordApi } from "../../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import {
    AudioFileRecordTechnical,
    ensureAudioFileRecordDetails
} from "../../../../../../../common/file-record-details/FileRecordDetails";
import { useFileRecordDetailsState } from "../../../../../hooks/useFileRecordDetailsState";
import { AudioTechnicalForm } from "./EditAudioTechnicalForm";

export interface EditAudioTechnicalInfoAsideContentProps {
    fileRecordId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const EditAudioTechnicalInfoAsideContent = (props: EditAudioTechnicalInfoAsideContentProps): JSX.Element => {
    const { fileRecordId, onSubmit, onCancel } = props;

    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordAudioTechnical } = useFileRecordApi();

    const updateAudioTechnical = (technicalInfo: AudioFileRecordTechnical) => {
        ensureAudioFileRecordDetails(fileRecordDetails);

        const request: UpdateFileRecordAudioTechnicalRequest = {
            id: fileRecordId,
            technical: mapToTechnicalInfo(technicalInfo)
        };

        setIsLoading(true);

        updateFileRecordAudioTechnical(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    technical: technicalInfo
                });

                onSubmit();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <AudioTechnicalForm
            isLoading={isLoading}
            onCancel={onCancel}
            onSubmit={updateAudioTechnical}
            validationResult={validationResult}
        />
    );
};

const mapToTechnicalInfo = (technicalInfo: AudioFileRecordTechnical) => {
    return {
        ...technicalInfo,
        audioBitRate: technicalInfo.audioBitRate || undefined,
        channelsCount: technicalInfo.channelsCount || undefined,
        sampleRate: technicalInfo.sampleRate || undefined
    };
};
